import type { RankTrackerCountry } from "app/pages/activation/types/api";

export const getIsMyCountryAvailable = (countries: RankTrackerCountry[], country: number): boolean =>
    countries.some((availableCountry) => availableCountry.code === country);
